import React from 'react';
import styled from "@emotion/styled";
import { keyframes } from '@emotion/react';

const bounce = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`
export const LoadingWrapper = styled.div`
  margin: auto;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 50px;
  height: 50px;
  animation: ${bounce} 2s linear infinite;
  margin-top: 5rem;  
`;

function Loading() {
  return (<>
    <LoadingWrapper></LoadingWrapper>   
  </>  
  )
}

Loading.propTypes = {}

export default Loading
